export default __webpack_public_path__ + "static/media/avatar.892b0558.svg";